export const MEMBER_RESOURCE_CACHE_VERSION = 1
const PREFIX = `privana_member_resource_v${MEMBER_RESOURCE_CACHE_VERSION}`

const clean = value => String(value || '').trim()
const part = value => encodeURIComponent(clean(value))

export function memberResourceCacheKey(scope = {}, resourceKey) {
  if (!clean(scope.clubCode) || !clean(scope.memberIdentity) || !clean(resourceKey)) return null
  return `${PREFIX}:${part(scope.clubCode)}:${part(scope.memberIdentity)}:${part(resourceKey)}`
}

export function readMemberResource(scope, resourceKey, { ttlMs = 15 * 60 * 1000 } = {}) {
  const key = memberResourceCacheKey(scope, resourceKey)
  if (!key || typeof window === 'undefined') return null
  try {
    const entry = JSON.parse(window.localStorage?.getItem(key) || 'null')
    const valid = entry?.schemaVersion === MEMBER_RESOURCE_CACHE_VERSION
      && entry?.clubCode === clean(scope.clubCode)
      && entry?.memberIdentity === clean(scope.memberIdentity)
      && entry?.resourceKey === clean(resourceKey)
      && Number.isFinite(entry?.updatedAt)
      && Object.prototype.hasOwnProperty.call(entry, 'data')
    if (!valid) {
      window.localStorage?.removeItem(key)
      return null
    }
    return { ...entry, stale: Date.now() - entry.updatedAt > ttlMs }
  } catch {
    try { window.localStorage?.removeItem(key) } catch { /* optional storage */ }
    return null
  }
}

/** One setItem replaces the complete, identity-bound read projection atomically. */
export function writeMemberResource(scope, resourceKey, data) {
  const key = memberResourceCacheKey(scope, resourceKey)
  if (!key || typeof window === 'undefined') return null
  const entry = {
    schemaVersion: MEMBER_RESOURCE_CACHE_VERSION,
    clubCode: clean(scope.clubCode),
    memberIdentity: clean(scope.memberIdentity),
    resourceKey: clean(resourceKey),
    updatedAt: Date.now(),
    data,
  }
  try { window.localStorage?.setItem(key, JSON.stringify(entry)); return entry } catch { return null }
}

export function clearMemberResource(scope, resourceKey) {
  const key = memberResourceCacheKey(scope, resourceKey)
  if (!key || typeof window === 'undefined') return false
  try { window.localStorage?.removeItem(key); return true } catch { return false }
}

/** Remove every persisted API projection belonging to a member (or club). */
export function clearMemberResources(scope = {}) {
  if (typeof window === 'undefined') return false
  const club = clean(scope.clubCode)
  const member = clean(scope.memberIdentity)
  try {
    for (let index = window.localStorage.length - 1; index >= 0; index -= 1) {
      const key = window.localStorage.key(index)
      if (!key?.startsWith(`${PREFIX}:`)) continue
      const [, keyClub, keyMember] = key.slice(PREFIX.length + 1).split(':')
      if ((!club || decodeURIComponent(keyClub) === club) && (!member || decodeURIComponent(keyMember) === member)) {
        window.localStorage.removeItem(key)
      }
    }
    return true
  } catch { return false }
}
